import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-huna-load-content',
    templateUrl: './huna-load-content.component.html',
    styleUrls: ['./huna-load-content.component.scss'],
    standalone: false
})
export class HunaLoadContentComponent implements OnInit {


    @Input()
    loading = false;
    @Input()
    diameter = 20;
    @Input()
    progress: number | undefined;
    @Input()
    color: 'primary' | 'accent' | 'warn' | '' = 'primary';
    @Input()
    type: 'mat-flat-button' | 'mat-raised-button' | 'mat-stroked-button' | 'mat-icon-button' | 'mat-fab' | 'mat-mini-fab' = 'mat-flat-button';


    constructor() {
    }

    ngOnInit(): void {
    }
    get progressIsSet() {
        return this.progress != null
    }
}
